import { CursorPaginationResult } from "@/types/CursorPaginationResult";
import { Axios } from "@/utils/axios";
import { Category } from "@/types/guidebookType";

export interface Article {
  title: string;
  type: "essential" | "tip";
  category: Category;
  index: string;
  tag: "장례 절차" | "장례 비용" | "장례 상식" | "장례 질문";
  date: string;
}
export const getArticlesSearch = (keyword: string | undefined) => {
  return async ({ pageParam = "" }) => {
    const page = pageParam ? new URL(pageParam).searchParams.get("page") : undefined;

    const { data } = await Axios.get<CursorPaginationResult<Article>>("/articles/search/", {
      params: {
        page,
        query: keyword,
      },
    });
    return data;
  };
};
